import React, { Component } from 'react';
import { Button } from 'reactstrap';
import GraphiQL from 'graphiql';
import fetch from 'isomorphic-fetch';

import mgr from '../../auth-config';

import 'bootstrap/dist/css/bootstrap.css';
import 'graphiql/graphiql.css';

import './main.css';

class Main extends Component {

    /**
     * Constructor.
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            isLoading: true
        }

        this.path = window.location.origin === "http://localhost:3000" ? "https://core-api.qa.selflystore.com" : window.location.origin 
    }

    /**
     * Before the component mounted.
     */
    componentWillMount() {
        mgr.getUser()
            .then(authData => {
                // if no auth data, do nothing
                if (!authData) {
                    // clear the user
                    this.setState({
                        ...this.state,
                        user: null,
                        isLoading: false
                    });
                    return;
                }
                // try to fetch user profile
                let url = `${this.path}/v3/me`;
                return fetch(url, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${authData.access_token}`
                    }
                }).then(data => data.json())
                    .then(profile => {
                        // else save the user
                        this.setState({
                            ...this.state,
                            user: {
                                access_token: authData.access_token,
                                user_name: authData.profile.name,
                                expires_at: authData.expires_at,
                                profile
                            },
                            isLoading: false
                        })
                    }).catch(err => {
                        // clear the user
                        this.setState({
                            ...this.state,
                            user: null,
                            isLoading: false
                        });
                        return;
                    });


            });
    }

    /**
     * Redirects user to sign in page
     */
    handleSignIn() {
        mgr.signinRedirect();
    }

    /**
     * Renders the component.
     */
    render() {
        return (
            <div className="App">
                {this.state.user ?
                    (
                        <GraphiQL fetcher={this.graphQLFetcher.bind(this)} />
                    ) : (
                        <div className="container mt-4">
                            <h2>GraphQL Sandbox</h2>
                            <span>Sign in to continue</span><br />
                            {this.state.isLoading ? (
                                <div className="mt-4">Loading....</div>
                            ) : (
                                    <Button onClick={this.handleSignIn.bind(this)} className="mt-2">Sign In</Button>
                                )}
                        </div>
                    )}
            </div>
        );
    }

    graphQLFetcher(params) {
        let url = `${this.path}/v4/graphql`;
        return fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user.access_token}`
            },
            body: JSON.stringify(params)
        })
            .then(data => data.json());
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main/main.js